import React from 'react';

import AdminAssignShiftsPage from './AdminAssignShiftsPage';
import { BUSINESS_MODE } from './bookingModes';

/** Direct booking for the Luxottica businesses: the admin booking page limited to their own stores and locums. */
const DirectBookingPage = () => <AdminAssignShiftsPage mode={BUSINESS_MODE} />;

DirectBookingPage.displayName = 'DirectBookingPage';
export default DirectBookingPage;
